import { createFileRoute } from "@tanstack/react-router";
import { seo } from "@/lib/seo";
import Windows from "@/pages/services/Windows";

export const Route = createFileRoute("/_site/services/windows")({
  head: () => ({
    ...seo({
      title: "Window Installation & Replacement | Kodiak Structures & Exteriors",
      description:
        "Energy-efficient window replacement throughout Minnesota. Lower energy bills, reduce noise, and boost home value. Free estimates.",
      path: "/services/windows",
    }),
  }),
  component: Windows,
});
